<template>
	<v-container class="outreach none-fluid link">
		<banner>Women In Robotics</banner>
		<div class="mx-auto container">
			<div>
				<div>
					<img style="width:100%;margin-left:auto;margin-right:auto;margin-bottom:10px;" :src="image" alt="Assembly at Monterey Hills Elementary School"/>
					<div v-html="$sanitize(intro)"></div>
					<img style="width:auto;margin-left:5px;margin-right:auto;margin-bottom:10px;align=right;" :src="image_icra" align="right">
					<div v-html="$sanitize(content)"></div>
					<br>
					<iframe :src="frame_src" style="width:100%;height:700px;"></iframe>
					<br>
				</div>
			</div><!-- /.container -->
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getWomenInRobotics } from "../../service/outreach/womenInRobotics";

export default {
	components: {
		Banner
	},
	data() {
		return {
			intro: {},
			content: {},
			image: {},
			frame_src: {},
			image_icra: {}			
		};
	},
	mounted() {
		getWomenInRobotics()
			.then(data => {
				this.content = data.content,
				this.image = data.image,
				this.frame_src = data.frame_src,
				this.intro = data.intro,
				this.image_icra = data.image_icra
				
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style>
  @import '../../css/sub.css';
</style>